// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__y-ReW","info":"PatientInfo_info__1H0XE"};